import { createContext, useMemo } from 'react'
import { tracker } from '@BUP/services/tracker'

export const TrackerContext = createContext()

export const TrackerContextProvider = ({ user, children }) => {
  const userTracker = useMemo(() => {
    /*
      TODO: identify has been use with the name instead of userId,
      so it's not possible to track the user with the userId for now.
      eventually try something like tracker.mixpanel.alias(user.id, user.name)
      and test if we don't lose the user tracking history
     */
    tracker.identify(user.name)
    tracker.setPeopleData({
      $name: user.name,
      $email: user.email,
      userId: user.id,
      name: user.name,
      email: user.email
    })
    return tracker
  }, [user])
  return (
    <TrackerContext.Provider key={user.id} value={userTracker}>
      {children}
    </TrackerContext.Provider>
  )
}
